class JSONValidator {
  validate(string) {
    try {
      JSON.parse(string);
      return true;
    } catch (error) {
      return false;
    }
  }
}
const jsonValidator = new JSONValidator();
export { jsonValidator };